<template>
  <div class="w-full h-full">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="formProps.pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span
          v-if="formProps.pageType !== 'read'"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ formProps.pageType === 'create' ? '新增' : '编辑' }}</span
        >
      </div>
    </div>
    <div
      class="w-full overflow-y-auto overflow-x-hidden"
      :class="[formProps.pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form ref="form" label-width="150px" class="mr-20px" :model="formData">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item
              label="承诺人"
              prop="pledgee"
              :rules="[
                {
                  required: true,
                  message: '请输入承诺人',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formData.pledgee"
                placeholder="请输入承诺人"
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item
              label="岗位"
              prop="postId"
              :rules="[
                {
                  required: true,
                  message: '请输入岗位',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formData.post"
                placeholder="请输入岗位"
                maxlength="50"
                show-word-limit
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="所属风险点" prop="belongRiskPoint">
              <PointSelect
                :id.sync="formData.belongRiskPointId"
                :name.sync="formData.belongRiskPointStr"
                :multiple="true"
                placeholder="请选择所属风险点"
                :disabled="formProps.pageType === 'read'"
                @getPointList="getPointList"
              ></PointSelect>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="风险点编号" prop="riskPointNumber">
              <el-input
                v-model="formData.riskPointNumber"
                placeholder="请输入风险点编号"
                clearable
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            :rules="[
              {
                required: true,
                message: '请选择关联风险区域',
                trigger: ['blur', 'change'],
              },
            ]"
          >
            <el-form-item label="关联风险区域" prop="associateRiskAreas">
              <el-select
                ref="associateRiskAreasArr"
                v-model="formData.associateRiskAreasArr"
                placeholder="请选择关联风险区域"
                class="w-full"
                clearable
                filterable
                multiple
                collapse-tags
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item
              label="主管领导"
              prop="supervisorLeadershipId"
              :rules="[
                {
                  required: true,
                  message: '请选择主管领导',
                  trigger: ['blur'],
                },
              ]"
            >
              <MultiplePersonSelect
                ref="multiplePersonSelect"
                v-model="formData.supervisorLeadershipId"
                :isMultiple="false"
                :disabled="formProps.pageType === 'read'"
              ></MultiplePersonSelect>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item
              label="承诺时间"
              prop="commitmentTime"
              :rules="[
                {
                  required: true,
                  message: '请选择承诺时间',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="formData.commitmentTime"
                :disabled="formProps.pageType === 'read'"
                class="!w-full"
                type="datetime"
                placeholder="请选择承诺时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="24">
            <el-form-item
              label="承诺内容"
              prop="commitmentContent"
              :rules="[
                {
                  required: true,
                  message: '请输入承诺内容',
                  trigger: ['blur', 'change'],
                },
              ]"
            >
              <el-input
                v-model="formData.commitmentContent"
                placeholder="请输入承诺内容"
                type="textarea"
                :rows="4"
                maxlength="5000"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" prop="annex">
              <form-upload
                v-model="formData.annex"
                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx']"
                :disabled="pageType === 'read'"
                :maxSize="20"
                :limit="999"
                uploadTipText="拖拽上传"
                :show-text="formProps.pageType === 'read'"
              ></form-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="w-full flex justify-center items-center mt-5 mb-5"
      v-if="formProps.pageType !== 'read' && formProps.pageType !== 'refreshPublish'"
    >
      <el-button type="primary" size="small" @click="submitForm" :loading="loading">保存</el-button>
      <el-button @click="closeDialog" size="small">取消</el-button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { SecurityResponsibilityCommitmentCardApi } from '@wiz-api/double-prevention-management'
import { forIn } from 'lodash'
import utils from '@/components/safety/enumField/utils'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import MultiplePersonSelect from '@/components/safety/FormSelect/MultiplePersonSelect'
import PointSelect from '../PointSelect/PointSelect'

const areaApi = new AreaApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const securityResponsibilityCommitmentCardApi = new SecurityResponsibilityCommitmentCardApi()
export default {
  name: 'staff-duty-form',
  components: {
    FormUpload,
    PointSelect,
    MultiplePersonSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    return {
      visible: true,
      loading: false,
      formData: {},
      areaList: [],
    }
  },
  mounted() {
    // 获取区域列表
    this.getAreaList()
    if (this.formProps.pageType === 'create') {
      // 获取用户信息，dev环境需要copy到public/config/setting.json,以便拿去本地信息
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const { sub, name } = userInfo?.profile
      // 承诺人赋值
      this.formData.pledgeeId = sub
      // 获取岗位信息
      this.getUserPost()
      // 承诺时间初始化
      this.formData.commitmentTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        forIn(newVal, (value, key) => {
          this.$set(this.formData, key, value)
        })
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      immediate: true,
    },
  },
  methods: {
    // 获取用户岗位信息
    async getUserPost() {
      const [err, res] = await eafOrganizationUnitUserApi.getUserDetail({
        id: this.formData.pledgeeId,
      })
      if (!err) {
        if (res?.userPosts?.length > 0) {
          this.formData.postId = res.userPosts[0]?.postId
          this.formData.post = res.userPosts[0]?.postName
        }
        this.formData.pledgee = res.name
      }
    },
    // 获取风险点列表
    getPointList(list) {
      const riskPointNumberList = []
      const areaIdList = []
      _.forEach(list, (item) => {
        // 风险点编号
        if (item.riskPointNumber) {
          riskPointNumberList.push(item.riskPointNumber)
        }
        // 风险区域id集合
        if (item.areaId) {
          areaIdList.push(item.areaId)
        }
      })
      this.formData.riskPointNumber = riskPointNumberList.join(',')
      this.formData.associateRiskAreasArr = areaIdList
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 表单提交
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          // 关联区域id
          this.formData.associateRiskAreas = this.formData.associateRiskAreasArr.join(',')
          // 关联区域label
          this.formData.associateRiskAreasStr = _.map(
            this.$refs.associateRiskAreasArr.selected,
            (item) => {
              return item.currentLabel
            }
          ).join(',')
          // 时间格式化
          this.formData.commitmentTime = this.formData.commitmentTime
            ? dayjs(this.formData.commitmentTime).format('YYYY-MM-DD HH:mm:ss')
            : undefined
          // 获取主管领导label
          this.formData.supervisorLeadership = this.$refs.multiplePersonSelect.getUserLabel()
          if (this.formProps.pageType === 'create') {
            const [err, res] = await securityResponsibilityCommitmentCardApi.create({
              body: this.formData,
            })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
          } else {
            const [err, res] = await securityResponsibilityCommitmentCardApi.update(
              this.formData.id,
              {
                body: this.formData,
              }
            )
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
          }
          this.loading = false
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss">
.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
